export default __webpack_public_path__ + "static/media/bootstrap.02e16df6.png";